<template lang="html">
  <b-container fluid class="_containerFluid">
    <b-row>
      <b-col lg="4" class="my-1">
        <b-form-group
          label="Kacheln"
          label-cols-sm="3"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-form-select v-model="filter" :options="filterData"></b-form-select>
        </b-form-group>
      </b-col>

      <!-- <b-col lg="4" class="my-1">
        <b-form-group
          label="Räume"
          label-cols-sm="3"
          label-align-sm="left"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            v-model="filter2"
            :options="filterData2"
          ></b-form-select>
        </b-form-group>
      </b-col> -->
      <b-col lg="1" class="desktop-clear-btn">
        <b-form-group label-cols-sm="1" label-align-sm="left" class="mb-0">
          <el-button
            class="btn-clear mobilehide"
            type="info"
            icon="el-icon-delete"
            circle
            @click="clearFilter"
          ></el-button>
          <el-button
            block
            class="btn-clear-mobile desktophide"
            variant="default"
            icon="el-icon-delete"
            @click="clearFilter"
          ></el-button>
        </b-form-group>
      </b-col>
    </b-row>
    <table class="table table-fixed">
      <thead>
        <tr>
          <th class="th-type">Type</th>
          <th class="th-wert">Wert</th>
          <th class="th-icon mobilehide"></th>
          <th class="th-sensor-name">Sensor-Name</th>
          <th class="th-ort">Ort</th>
          <th class="th-date mobilehide">Letzte Daten</th>
          <th class="th-charts mobilehide">Charts</th>
        </tr>
      </thead>
      <tbody :style="{ height: tableHeight }">
        <div
          v-for="(item, index) in filterBy(tableData)"
          :key="index"
          data-toggle="collapse"
          data-target="#2237"
          class="accordion-toggle"
        >
          <tr :class="getClass(item)" class="sensor-table">
            <td class="th-type" @click="toggleDetails(item.eui)">
              <img
                v-if="
                  item.deviceType.niota_maps.icon_class ==
                    'far fa-thermometer-half'
                "
                class="tbl-icons"
                src="../../assets/icons/thermometer-half-regular.svg"
                alt="temperature icon"
              />
              <img
                v-if="item.deviceType.niota_maps.icon_class == 'fas fa-tint'"
                class="tbl-icons"
                src="../../assets/icons/tint-solid.svg"
                alt="humidity icon"
              />
              <img
                v-if="item.deviceType.niota_maps.icon_class == 'fas fa-volume'"
                class="tbl-icons-sound"
                src="../../assets/icons/volume-up-solid.svg"
                alt="sound icon"
              />
              <img
                v-if="item.deviceType.niota_maps.icon_class == 'fas fa-walking'"
                class="tbl-icons"
                src="../../assets/icons/walking-solid.svg"
                alt="walking icon"
              />
              <img
                v-if="item.deviceType.niota_maps.icon_class == 'fas fa-cloud'"
                class="tbl-icons-cloud"
                src="../../assets/icons/cloud-solid.svg"
                alt="cloud icon"
              />
              <img
                v-if="
                  item.deviceType.niota_maps.icon_class == 'far fa-door-closed'
                "
                class="tbl-icons-door"
                src="../../assets/icons/door-closed-solid.svg"
                alt="door icon"
              />
              <img
                v-if="
                  item.deviceType.niota_maps.icon_class == 'fas fa-lightbulb'
                "
                class="tbl-icons"
                src="../../assets/icons/lightbulb-solid.svg"
                alt="light icon"
              />
              <img
                v-if="item.deviceType.niota_maps.icon_class == 'fas fa-parking'"
                class="tbl-icons"
                src="../../assets/icons/parking-solid.svg"
                alt="light icon"
              />
              <img
                v-if="
                  item.deviceType.niota_maps.icon_class == 'fas fa-th-large'
                "
                class="tbl-icons"
                src="../../assets/icons/th-large-solid.svg"
                alt="light icon"
              />
              <img
                v-if="item.deviceType.niota_maps.icon_class == 'far fa-wrench'"
                class="tbl-icons"
                src="../../assets/icons/wrench-solid.svg"
                alt="light icon"
              />
              <img
                v-if="item.deviceType.niota_maps.icon_class == 'far fa-plug'"
                class="tbl-icons"
                src="../../assets/icons/plug-solid.svg"
                alt="light icon"
              />
              <img
                v-if="item.deviceType.niota_maps.icon_class == 'fas fa-smile'"
                class="smile-icons"
                src="../../assets/icons/smile-solid.svg"
                alt="light icon"
              />
              <img
                v-if="
                  item.deviceType.niota_maps.icon_class == 'fas fa-tachometer'
                "
                class="smile-icons"
                src="../../assets/icons/tachometer-solid.svg"
                alt="light icon"
              />
            </td>
            <td @click="deviceDetailRequested(item)" class="th-wert">
              {{ item.parsedData.output }}
            </td>
            <td @click="deviceDetailRequested(item)" class="th-icon mobilehide">
              <span v-if="item.hasAlert">
                <i
                  class="fas fa-times-circle tile-icon-error"
                  v-if="checkCondition(item)"
                ></i>
                <i
                  class="fas fa-exclamation-circle tile-icon-warning"
                  v-else
                ></i>
              </span>
              <span v-else>
                <i class="el-icon-success tile-icon-ok"></i>
              </span>
            </td>
            <td @click="deviceDetailRequested(item)" class="th-sensor-name">
              {{ item.title }}
            </td>
            <td @click="deviceDetailRequested(item)" class="th-ort">
              {{ item.description }}
            </td>
            <td @click="deviceDetailRequested(item)" class="th-date mobilehide">
              {{ item.lastPacketTimestamp }}
            </td>
            <td class="th-charts mobilehide">
              <span
                class="charts-icon"
                @click="buildChartdata(item)"
                v-if="item.charts"
                ><i class="fas fa-chart-line"></i
              ></span>
              <el-tooltip
                v-else
                :content="
                  'Die Daten für diesen Sensortyp können nicht visualisiert werden.'
                "
                :open-delay="100"
                :hide-after="5000"
                placement="right"
                effect="light"
              >
                <span class="charts-icon"><i class="fas fa-info"></i></span>
              </el-tooltip>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="hiddenRow">
              <div
                :id="item.eui"
                class="accordian-body"
                :ref="item.eui"
                :class="toggleClass"
              >
                <div class="tbl-details">
                  <h1 class="tbl-details-title">Zählernummer:</h1>
                  <p>{{ getMeterNr(item.eui) }}</p>
                </div>
              </div>
            </td>
          </tr>
        </div>
      </tbody>
    </table>
  </b-container>
</template>

<script>
export default {
  props: {
    tableData: Array,
    tableType: String,
    alertTable: Boolean,
    tableHeight: String
  },
  data() {
    return {
      filterData: this.$store.state.filterData,
      filter: "",
      holleyMeter: {
        // Zählernummer für Stromzähler
        "847D501619122869": "1HLY0100002015",
        "847D501619122864": "1HLY0100002014",
        "847D50161912280F": "1HLY0100002006",
        "847D5016191227F7": "1HLY0100002004",
        "212A06FEFFE5A0CC": "1DZG0060027404",
        "232A06FEFFE5A0CC": "1DZG0060027405",
        "222A06FEFFE5A0CC": "1DZG0060027403"
      },
      toggleClass: "hide"
    };
  },
  methods: {
    tableRowClicked(row) {
      this.$emit("tableRowClicked", row);
    },
    deviceDetailRequested(row) {
      this.$emit("deviceDetailRequested", row);
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    tableRowClassName({ row }) {
      if (row.hasAlert) {
        return "warning-row";
      }
      return "";
    },
    show3DMapEvent() {
      this.$emit("show3DMapEvent", this.tableData);
    },
    buildChartdata(row) {
      this.$emit("buildChartdata", row);
    },
    filterBy(data) {
      let filter = this.filter;
      return data.filter(function(item) {
        if (filter) {
          return item.tile_name === filter;
        } else {
          return item;
        }
      });
    },
    clearFilter() {
      this.filter = "";
    },
    getClass(item) {
      if (item.hasAlert) {
        return "table-danger";
      }
    },
    getMeterNr(deviceEUI) {
      return this.holleyMeter[deviceEUI];
    },
    toggleDetails(deviceEUI) {
      if (Object.keys(this.holleyMeter).indexOf(deviceEUI) !== -1) {
        if (this.$refs[deviceEUI][0].classList.contains("hide")) {
          this.$refs[deviceEUI][0].classList.remove("hide");
        } else {
          this.$refs[deviceEUI][0].classList.add("hide");
        }
      }
    },
    checkCondition(device) {
      if (
        device.cssIconClass !== "brandschott" &&
        device.cssIconClass !== "parking" &&
        device.cssIconClass !== "window"
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style media="screen">
div.effect {
  width: 3px;
  height: 40px;
  background: red;
  position: relative;
  animation: mymove 2s;
  opacity: 0.5;
}

/* Standard syntax */
@keyframes mymove {
  0% {
    top: 0px;
    background: red;
    height: 2px;
    opacity: 1;
  }
  100% {
    top: 0px;
    background: red;
    height: 40px;
    opacity: 0.5;
  }
}
</style>
